module.exports = __webpack_public_path__ + "fonts/caveat-v23-latin-regular.eb5673b.eot";